import { render, staticRenderFns } from "./taskdetial.vue?vue&type=template&id=55278364&scoped=true&"
import script from "./taskdetial.vue?vue&type=script&lang=js&"
export * from "./taskdetial.vue?vue&type=script&lang=js&"
import style0 from "./taskdetial.vue?vue&type=style&index=0&id=55278364&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55278364",
  null
  
)

export default component.exports